var React = require('react');

function CustomizeProfiles (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41 9H7V33H21.0435V15H41V9ZM24 33V39H32.8696V25.5H41V18H24V33ZM21.0435 39V36H10.6957V39H21.0435ZM41 28.5H35.8261V39H41V28.5Z","stroke":"#E8EFFF","strokeOpacity":"0.7","strokeWidth":"1.5"}));
}

CustomizeProfiles.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CustomizeProfiles;

CustomizeProfiles.default = CustomizeProfiles;
